// extracted by mini-css-extract-plugin
export default {"grid":"FeedbackList_grid__g8n2L"};